var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0009,
    cy: 13.9999,
    r: 9.69231,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0118 13.2929C9.62127 12.9024 8.9881 12.9024 8.59758 13.2929C8.20706 13.6834 8.20706 14.3166 8.59758 14.7071L10.0118 13.2929ZM12.3047 17L11.5976 17.7071C11.9881 18.0976 12.6213 18.0976 13.0118 17.7071L12.3047 17ZM19.0118 11.7071C19.4023 11.3166 19.4023 10.6834 19.0118 10.2929C18.6213 9.90237 17.9881 9.90237 17.5976 10.2929L19.0118 11.7071ZM8.59758 14.7071L11.5976 17.7071L13.0118 16.2929L10.0118 13.2929L8.59758 14.7071ZM13.0118 17.7071L19.0118 11.7071L17.5976 10.2929L11.5976 16.2929L13.0118 17.7071Z",
    fill: "#3E3E3E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.9231,
    stroke: "white",
    strokeWidth: 2.15385
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedTick);
export default __webpack_public_path__ + "static/media/selected-tick.ca9fb87c90226f50238d4d05d2c24af6.svg";
export { ForwardRef as ReactComponent };